"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOWNPAYMENT_TRIGGER_LABELS = exports.PAYMENT_TRIGGER_EVENT_ORDER = exports.PAYMENT_TRIGGER_EVENT_LABELS = void 0;
exports.paymentTriggerEventLabel = paymentTriggerEventLabel;
exports.comparePaymentTriggerEvents = comparePaymentTriggerEvents;
exports.formatPaymentTrigger = formatPaymentTrigger;
exports.downpaymentTriggerLabel = downpaymentTriggerLabel;
// Maps the Prisma TS-safe enum identifier back to the DB / display string
// (the @map value from `payment_trigger_event_enum` in schema.prisma).
exports.PAYMENT_TRIGGER_EVENT_LABELS = {
    ATA_at_Final_destination: 'ATA at Final destination',
    BL_confirmed: 'BL confirmed',
    BL_issuance: 'BL issuance',
    BL_release: 'BL release',
    Booking: 'Booking',
    Customs_Clearance: 'Customs Clearance',
    DP: 'DP',
    ETA_at_Final_destination: 'ETA at Final destination',
    ETD: 'ETD',
    Fixation: 'Fixation',
    Inspection: 'Inspection',
    Invoice: 'Invoice',
    Loading: 'Loading',
    Order_Signed_Date: 'Order Signed Date',
    ATA_at_PoD: 'ATA at PoD',
    ETA_at_PoD: 'ETA at PoD',
    ATA_at_Customer_Site: 'ATA at Customer Site',
    Sorting_at_buyer_s_factory: "Sorting at buyer's factory",
};
function paymentTriggerEventLabel(event) {
    if (event === null)
        return null;
    return exports.PAYMENT_TRIGGER_EVENT_LABELS[event] ?? event;
}
// Trigger events follow the deal → delivery lifecycle so the dropdown reads
// in the order a transaction actually moves, rather than the enum's
// alphabetical default. First pass open to ops refinement; unlisted events
// sort to the end.
exports.PAYMENT_TRIGGER_EVENT_ORDER = [
    'Order_Signed_Date',
    'Fixation',
    'DP',
    'Booking',
    'Loading',
    'ETD',
    'BL_issuance',
    'BL_confirmed',
    'BL_release',
    'Invoice',
    'ETA_at_PoD',
    'ATA_at_PoD',
    'Customs_Clearance',
    'Inspection',
    'ETA_at_Final_destination',
    'ATA_at_Final_destination',
    'ATA_at_Customer_Site',
    'Sorting_at_buyer_s_factory',
];
function comparePaymentTriggerEvents(a, b) {
    const rank = (e) => {
        const i = exports.PAYMENT_TRIGGER_EVENT_ORDER.indexOf(e);
        return i === -1 ? exports.PAYMENT_TRIGGER_EVENT_ORDER.length : i;
    };
    const diff = rank(a) - rank(b);
    return diff !== 0 ? diff : a.localeCompare(b);
}
function formatPaymentTrigger(trigger) {
    if (trigger?.event == null)
        return '—';
    const offset = trigger.offsetDays === null ? null : Number(trigger.offsetDays);
    if (offset !== null && !Number.isNaN(offset) && offset !== 0) {
        const timing = trigger.timing ?? 'After';
        return `${String(Math.abs(offset))} days ${timing} ${trigger.event}`;
    }
    if (trigger.timing !== null) {
        return `${trigger.timing} ${trigger.event}`;
    }
    return `On ${trigger.event}`;
}
// Advance-downpayment trigger labels (launchpad parity, QA #463). Maps the
// Prisma enum identifier back to its display string, distinct from the BL
// milestone events in PAYMENT_TRIGGER_EVENT_LABELS.
exports.DOWNPAYMENT_TRIGGER_LABELS = {
    Advance_with_Proforma: 'Advance with Proforma',
    Against_Loading: 'Against Loading',
    Against_Released_BL: 'Against Released BL',
    ATA: 'ATA',
    Booking: 'Booking',
    ETA: 'ETA',
    Invoice: 'Invoice',
    Loading: 'Loading',
    Order_Signed_Date: 'Order Signed Date',
};
function downpaymentTriggerLabel(trigger) {
    if (trigger === null)
        return null;
    return exports.DOWNPAYMENT_TRIGGER_LABELS[trigger] ?? trigger;
}
//# sourceMappingURL=payment-trigger.js.map